import HighlightedItem from '@pelckmans/elementis/components/highlighted-item';
import { MedialinkDialogHeaderTagsWithoutPillGroup } from '../../../../../pages/material/components/MedialinkDialogHeaderTags';
import { ComponentProps } from 'react';
import ScorableProgress from '../../../../../pages/material/toc/components/ScorableProgress';
import { useExerciseManagerContext } from '../contexts/ExerciseManagerContext';
import { Module } from '../../../../../api/module';
import { Medialink } from '../../../../../api/medialink';
import { Status } from '../../../../../utils/results';
import { calculateScore } from '../../../util/calculateScore';

interface Props {
  title: string;
  module: Module;
  medialink: Medialink;
  result: {
    title: string;
    score: {
      maximum: number;
      achievable: number;
      achieved: number;
    };
  };
  percentageTitle: string;
  scoreTitle: string;
  status?: Exclude<Status, 'not-started' | 'not-finished' | 'pending-grading'>;
}

function ExerciseHighLightedItem({ title, module, medialink, result, percentageTitle, scoreTitle, status }: Props) {
  const score: ComponentProps<typeof ScorableProgress>['score'] = {
    ...result.score,
    status, // This should come from the result, but we don't have it yet in the sessions https://pelckmans.atlassian.net/browse/PAKP-9508
  };

  const { showScore } = useExerciseManagerContext();

  return (
    <HighlightedItem
      variant="exercise"
      title={title}
      exerciseName={medialink.name}
      tags={{
        'aria-label': undefined,
        role: undefined,
        children: <MedialinkDialogHeaderTagsWithoutPillGroup module={module} material={medialink} />,
      }}
      result={{
        title: result.title,
        value: <ScorableProgress unachievable={medialink.unachievable} score={score} />,
      }}
      percentage={
        medialink.unachievable
          ? undefined
          : {
              title: percentageTitle,
              value: calculateScore(result.score),
            }
      }
      score={
        showScore && !medialink.unachievable
          ? {
              title: scoreTitle,
              value: `${result.score.achieved} / ${result.score.maximum}`,
            }
          : undefined
      }
    />
  );
}

export default ExerciseHighLightedItem;
